module.exports = __webpack_public_path__ + "img/electric-works-gas.98eb56e0.webp";